// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Order.yaml
// Generated: 2025-11-13T17:17:07.081Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateOrder, UpdateOrder, Order } from '@/types/sales/Order';

/**
 * Order Service
 * CRUD operations for Order via the ABP API.
 */
export const orderService = new EntityService<Order, CreateOrder, UpdateOrder>(
  '/api/sales/order',
  'Order',
);
